import { render, staticRenderFns } from "./dialog-activity-info.vue?vue&type=template&id=b19c1d6c&scoped=true"
import script from "./dialog-activity-info.vue?vue&type=script&lang=js"
export * from "./dialog-activity-info.vue?vue&type=script&lang=js"
import style0 from "./dialog-activity-info.vue?vue&type=style&index=0&id=b19c1d6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b19c1d6c",
  null
  
)

export default component.exports